import { atom, selector } from 'recoil';
import { IPhotocardAutoSet, IPhotoCard } from '@typings/photocard/photocard.interface';

export const photocardAutoSetState = atom<IPhotocardAutoSet | null>({
  key: 'photocardAutoSetState',
  default: null,
});

export const photocardAutoSetLoadingState = atom<boolean>({
  key: 'photocardAutoSetLoadingState',
  default: true,
});

// 📍 대표 포토카드 (멤버란에서 지정한 대표 캐릭터)
export const mainPhotocardDataState = atom<IPhotoCard | null>({
  key: 'mainPhotocardDataState',
  default: null,
});

// 📍 대표 폼 데이터 (폼에서 지정한 대표 캐릭터)
export interface IRepresentativeForm {
  id: string;
  title: string;
  subTitle?: string;
  thumbnail?: string;
  camp?: string;
  formConfigId: string;
  formConfigTitle?: string;
  authorUid?: string;
  /** 폼 컬렉션 경로 (form, form2 등) - 링크 이동에 사용 */
  formPath?: string;
}

export const representativeFormDataState = atom<IRepresentativeForm | null>({
  key: 'representativeFormDataState',
  default: null,
});

// 📍 최종 대표 캐릭터 (포토카드 우선, 없으면 폼)
// 통합된 인터페이스로 반환
export interface IMainCharacter {
  id: string;
  title: string;
  subTitle?: string;
  thumbnail?: string;
  camp?: string;
  type: 'photocard' | 'form';
  // 원본 데이터 참조
  photocard?: IPhotoCard;
  form?: IRepresentativeForm;
}

export const mainCharacterState = selector<IMainCharacter | null>({
  key: 'mainCharacterState',
  get: ({ get }) => {
    const photocard = get(mainPhotocardDataState);
    const form = get(representativeFormDataState);

    // 포토카드 우선
    if (photocard) {
      return {
        id: photocard.id || '',
        title: photocard.title || '',
        subTitle: photocard.subTitle,
        thumbnail: photocard.thumbnail,
        camp: photocard.camp,
        type: 'photocard' as const,
        photocard,
      };
    }

    // 폼 데이터
    if (form) {
      return {
        id: form.id,
        title: form.title,
        subTitle: form.subTitle,
        thumbnail: form.thumbnail,
        camp: form.camp,
        type: 'form' as const,
        form,
      };
    }

    return null;
  },
});